export interface GovernanceRevision {
  id: string;
  knowledgeSourceId: string;
  chatbotId: string;
  name: string;
  content: string;
  status: string;
  stamp: string;
  baseVersion: number;
  currentPublishedVersion: number;
  restoredFromVersionId: string | null;
  restoredFromVersion: number | null;
  createdByUserId: string;
  createdAt: string;
  submittedAt: string | null;
  reviewedAt: string | null;
  reviewComments: string | null;
  publishedAt: string | null;
  publishedVersion: number | null;
}

export function revisionCapabilities(
  revision: GovernanceRevision,
  _userId: string | undefined,
  permissions: { manage: boolean; review: boolean; publish: boolean },
) {
  const creator = permissions.manage;
  const active = ["draft", "submitted", "approved", "rejected"].includes(revision.status);
  return {
    edit: creator && ["draft", "rejected"].includes(revision.status),
    approve: permissions.review && revision.status === "submitted",
    reject: permissions.review && ["submitted", "approved"].includes(revision.status),
    publish: permissions.publish && revision.status === "approved",
    cancel: creator && active,
  };
}

export function revisionHasUnsavedChanges(
  revision: Pick<GovernanceRevision, "name" | "content">,
  name: string,
  content: string,
) {
  return revision.name !== name || revision.content !== content;
}

export function revisionSaveBody(name: string, content: string, stamp: string) {
  return { name, content, stamp };
}
